import(/* webpackMode: "eager" */ "/app/app/components/CTALink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/LanguageSwitcher.tsx");
